import React from "react";
import "./LocationMessageContent.scss";
import LazyLoad from "react-lazy-load";
import IconWithBackground from "containers/chat/IconWithBackground/IconWithBackground";
import { MdLocationOn } from "react-icons/md";
import _colors from "styles/colors.module.scss";
import { setLocationMessageForDealerSuggestions } from "actions/dealerSuggestionActions";
import { connect } from "react-redux";
import DealerLocationTabService from "services/DealerLocationTabService";
const { darkBlue } = _colors;

function LocationMessageContent(props) {
  const { message, isTransferred, highlighted, messageSource } = props;
  const highlightedClass = highlighted ? "highlighted" : "";
  const transferredClass = isTransferred & !highlighted ? "transferred" : "";
  const { latitude, longitude } = message;
  const encryptedGoogleAPIKey = window.apiKeys.googleAPIKey;
  const decryptedGoogleAPIKey = atob(encryptedGoogleAPIKey);
  // Static image instead of the interactive Maps JS widget: the widget injects inline
  // <style> tags, which the portal's CSP (style-src 'self') blocks.
  const coordinates = `${latitude},${longitude}`;
  const staticMapUrl =
    "https://maps.googleapis.com/maps/api/staticmap" +
    `?center=${encodeURIComponent(coordinates)}&zoom=15&size=300x180&scale=2` +
    `&markers=${encodeURIComponent(`color:red|${coordinates}`)}` +
    `&key=${encodeURIComponent(decryptedGoogleAPIKey)}`;
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(coordinates)}`;

  const { activeLocationMessage } = props;
  const isCurrentMessageActiveLocationSuggestion =
    activeLocationMessage &&
    activeLocationMessage.messageId === message.messageId;
  const bulbColor = isCurrentMessageActiveLocationSuggestion
    ? "#fff"
    : darkBlue;
  const iconBgColor = isCurrentMessageActiveLocationSuggestion
    ? darkBlue
    : "#fff";
  const boxShadowClass = !isCurrentMessageActiveLocationSuggestion
    ? "icon-with-shadow"
    : "";

  const activateDealerLocationTab = () => {
    props.setLocationMessageForDealerSuggestions(message);
    DealerLocationTabService.suggestDealersFor(message);
  };

  return (
    <div
      className={`location-msg-ctr ${transferredClass} ${highlightedClass}`}
      data-testid="location-message-content"
    >
      <LazyLoad placeholder="loading map" offset={100} height="100%" width="100%">
        <a
          className="location-container"
          href={googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          title="Open in Google Maps"
        >
          <img
            className="location-map"
            src={staticMapUrl}
            alt={`Map of ${message.locationName || coordinates}`}
          />
        </a>
      </LazyLoad>
      <div className="location-info">
        {message.locationName && (
          <div className="caption-content">{message.locationName}</div>
        )}
        {message.address && (
          <div className="caption-content">{message.address}</div>
        )}
        <div className="caption-content">
          <b>Latitude:</b> {latitude}
        </div>
        <div className="caption-content">
          <b>Longitude:</b> {longitude}
        </div>
      </div>
      {messageSource === "from" && (
        <div
          className={`dealer-suggestion ${boxShadowClass}`}
          onClick={activateDealerLocationTab}
        >
          <IconWithBackground
            icon={<MdLocationOn color={bulbColor} size="1.5em" />}
            backgroundColor={iconBgColor}
          />
        </div>
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  activeLocationMessage: state.dealerLocationSuggestion.activeLocationMessage,
});

const mapDispatchToProps = {
  setLocationMessageForDealerSuggestions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationMessageContent);
